import { InjectionToken, Signal } from '@angular/core';

export interface HeaderDebugHost {
  readonly isBrowser: boolean;
  readonly hostBindingEnabled: boolean;
  readonly trackScrollEnabled: unknown;
  readonly hasScrolled: Signal<boolean | undefined>;
  readonly isFixed: Signal<boolean | undefined>;
  readonly scrolledStatus: Signal<'top' | 'scrolled' | 'initial' | null | undefined>;
  readonly scrollDirection: Signal<'up' | 'down' | null | undefined>;
  readonly overContentLg: Signal<boolean | undefined>;
  readonly overContentSm: Signal<boolean | undefined>;
  readonly isOverContentAtTopLg: Signal<boolean | undefined>;
  readonly isOverContentAtTopSm: Signal<boolean | undefined>;
  readonly overContentScrolledLg: Signal<unknown>;
  readonly overContentScrolledSm: Signal<unknown>;
  readonly logoFilter: Signal<string | undefined>;
  readonly hasDifferentScrolledClass: Signal<boolean | undefined>;
  readonly headerCustomizationClass: Signal<string>;
}

export const HEADER_DEBUG_HOST = new InjectionToken<HeaderDebugHost>('HEADER_DEBUG_HOST');
